import React, { Component } from 'react';
import { Label } from 'office-ui-fabric-react';
import './styles.scss';
import { withTranslation } from 'react-i18next';

class FieldLabel extends Component {
  render() {
    let { labelText = '', isRequired = true, isDisabled = false, t } = this.props;
    return (
      <div className={`label-wrapper label-wrapper-${isDisabled}`}>
        <Label className="label-style" required={isRequired}>{labelText}</Label>
        {isRequired ? <Label className="required-label" >{t('required')}</Label> : <Label className="required-label">{t('optional')}</Label>}
      </div>
    )
  }
}

export default withTranslation()(FieldLabel);